<template>
    <tr>
        <td>{{ group?.title }}</td>
        <td>
            <div class="btn_group">
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToFirst()">
                    <v-icon>mdi-chevron-double-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToPrevious()">
                    <v-icon>mdi-chevron-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (groups.length - 1)" @click="handlerMoveToNext()">
                    <v-icon>mdi-chevron-down</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (groups.length - 1)" @click="handlerMoveToLast()">
                    <v-icon>mdi-chevron-double-down</v-icon>
                </button>
            </div>
        </td>
        <td class="txt_center">
            <button class="btn btn_s btn_white ico" @click="showGroupSettingPopup"><v-icon>mdi-pencil</v-icon> {{ $t('common.edit') }}</button>
        </td>
    </tr>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'

import { SpaceNavigationAction } from '../Enums/SpaceNavigationAction.js'

export default {
    props: {
        item: Object,
        index: Number,
        groups: Array
    },
    data() {
        return {
            group: {}
        }
    },
    watch: {
        item: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                this.group = deepCopy(newValue)
            }
        }
    },
    computed: {

    },
    methods: {
        handlerMoveToFirst() {
            this.$emit('updateOrder', SpaceNavigationAction.FIRST, this.index)
        },
        handlerMoveToNext() {
            this.$emit('updateOrder', SpaceNavigationAction.NEXT,  this.index)
        },
        handlerMoveToPrevious() {
            this.$emit('updateOrder', SpaceNavigationAction.PREVIOUS, this.index)
        },
        handlerMoveToLast() {
            this.$emit('updateOrder', SpaceNavigationAction.LAST, this.index)
        },
        showGroupSettingPopup() {
            this.$emit('showGroupSettingPopup', this.group)
        }
    }
}
</script>